export const Mainlaystyle = (theme) => ({
  rootBox: {
    display: "grid",
    gridTemplateColumns: "1.05fr 5fr",
    height: "100vh",
    width: "100vw",
    overflowX: "hidden",
  },
  componentDiv: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.primary.backgroundMain,
  },

  outletDiv: {
    p: 2,
    height: "100vh",
    overflowY: "auto",
  },

  HeaderDiv: {
    height: "10vh",
    borderBottom: `1px solid ${theme.palette.border.thin}`,
  },
});

export const sidenavStyle = (theme) => ({
  logo: {
    width: "45px",
    height: "45px",
    objectFit: "contain",
    borderRadius: "0.5rem",
    border: `1px solid ${theme.palette.border.thin}`,
  },

  icon: {
    width: 40,
    height: 40,
    borderRadius: 2,
    bgcolor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  active: {
    borderRadius: 1,
    mb: 0.5,
    color: theme.palette.primary.main,
    bgcolor: "rgba(255, 162, 0, 0.1)",
    fontWeight: "bold",
    fontSize: theme.palette.textSize.md,
  },

  inactive: {
    fontWeight: "bold",
    borderRadius: 1,
    mb: 0.5,
    color: "#1c0e00",
    bgcolor: "transparent",
    "&:hover": {
      bgcolor: "rgba(224,221,220,0.3)",
    },
  },

  iconActive: {
    color: theme.palette.primary.main,
    minWidth: 36,
  },

  iconInactive: {
    color: "#1c0e00",
    minWidth: 36,
  },

  logoDiv: {
    borderBottom: `1px solid ${theme.palette.border.thin}`,
    height: "12vh",
    display: "flex",
    alignItems: "center",
    px: 2,
  },

  sidenavBody: {
    height: "88vh",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
    },
  },

  versionDiv: {
    mt: 1,
    p: 1,
    border: `1px solid ${theme.palette.border.thin}`,
    borderRadius: 1,
    "&:hover": {
      bgcolor: "rgba(224,221,220,0.2)",
      borderColor: `${theme.palette.border.thin}`,
    },
  },

  sidenavLinkText: {
    '& .MuiListItemText-primary': {
      fontSize: theme.palette.textSize.xs,
      fontWeight: 'bold'
    },
  },

  titleHeading: {
    fontWeight: 600,
    color: theme.palette.text.md,
    fontSize: theme.palette.textSize.sm,
  },

  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: theme.palette.textSize.xs
  },

  notifyCount: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: "12px",
    px: 1,
    borderRadius: "12px",
    minWidth: "22px",
    textAlign: "center",
  },
});

export const HeaderStyles = (theme) => ({
  appBar: {
    boxShadow: "none",
    p: 0,
    px: 2,
    minHeight: "10vh",
    borderBottom: `0px solid ${theme.palette.border.thin}`,
  },
  title: {
    fontSize: theme.palette.textSize.sm,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: theme.palette.textSize.sm,
    color: theme.palette.text.secondary,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 0,
    minHeight: "10vh",
  },
  iconButton: {
    position: "relative",
    width: 40,
    height: 40,
  },
  bellIcon: {
    width: 20,
    height: 20,
    color: theme.palette.text.primary,
  },
  badge: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: theme.palette.textSize.xs,
    width: 20,
    height: 20,
    minWidth: 20,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  version: {
    mb: 2,
    p: 1,
    borderBottom: `1px solid ${theme.palette.border.thin}`,
    borderRadius: 1,
    bgcolor: "#fffdf8",
  },
});

export const logoutStyles = (theme) => ({
  rootDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    my: 2,
  },

  title: {
    fontWeight: "bold",
    fontSize: theme.palette.textSize.xl,
    textAlign: "center",
    pb: 1,
  },

  subtitle: {
    textAlign: "center",
    fontSize: theme.palette.textSize.md,
    color: "text.secondary",
  },

  btnDiv: {
    justifyContent: "center",
    gap: 2,
    pb: 2
  },

  

  
})